module.exports = __webpack_public_path__ + "static/media/galerija_2014 (3).6efadbd0.jpg";